var exports = {
  "k": "xe564cbfb--30a251--container",
};

module.exports = exports;
